import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@collaborate-health/uikit'
import { SyntheticEvent } from 'react'

export interface ExportGalleryOptionsDialogProps {
  isExportGalleryOptionsDialogOpen: boolean
  closeDialog: () => void
  next: () => void
  isShowProgress: boolean
  setExportGalleryOption: (e: SyntheticEvent<Element, Event>, value: number) => void
  selectedOption: number
  exportOptions: Array<{ Id: number; Value: string }>
}

const ExportGalleryOptionsDialog: React.FC<ExportGalleryOptionsDialogProps> = ({
  isExportGalleryOptionsDialogOpen,
  closeDialog,
  next,
  setExportGalleryOption,
  selectedOption,
  exportOptions,
}) => {
  return (
    <Dialog open={isExportGalleryOptionsDialogOpen} maxWidth='xs' fullWidth onClose={closeDialog}>
      <DialogTitle>Select data you would like to export</DialogTitle>
      <DialogContent>
        <RadioGroup value={selectedOption}>
          {exportOptions.map((option) => (
            <FormControlLabel
              key={option.Id}
              value={option.Id}
              control={<Radio />}
              label={option.Value}
              onChange={(e) => setExportGalleryOption(e, option.Id)}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={closeDialog}>
          Close
        </Button>

        <Button color='primary' variant='contained' onClick={next}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportGalleryOptionsDialog

